module.exports = __webpack_public_path__ + "bd3f94f71a7ec82059c5525e72c3e327.png";